import { FeaturedCategorySection } from './featured-category-section';

export class HeaderImageCarouselSection extends FeaturedCategorySection {}
